export const base64ToBlob = async (base64String: string): Promise<Blob> => {
    const byteCharacters = atob(base64String);
  
    const byteArrays: Uint8Array[] = Array.from(
      { length: Math.ceil(byteCharacters.length / 512) },
      (_, index) => {
        const start = index * 512;
        const end = start + 512;
        const slice = byteCharacters.slice(start, end);
        const byteNumbers = Array.from(slice, (char) => char.charCodeAt(0));
        return new Uint8Array(byteNumbers);
      }
    );
  
    return new Blob(byteArrays, { type: 'application/pdf' });
  };